export default "__VITE_ASSET__670b06cc__"